import styled from 'react-emotion';
export var ContentContainer =
/*#__PURE__*/
styled("div", {
  target: "e1w6ljo70"
})("display:flex;flex:1;padding:10px 50px 0;");
export var EndHeader =
/*#__PURE__*/
styled("h1", {
  target: "e1w6ljo71"
})("color:#fff;display:flex;margin:0;");
export var PresenterContent =
/*#__PURE__*/
styled("div", {
  target: "e1w6ljo72"
})("display:flex;flex:1;flex-direction:column;height:100%;width:100%;");
export var PreviewPane =
/*#__PURE__*/
styled("div", {
  target: "e1w6ljo73"
})("display:flex;flex:1;flex-wrap:wrap;height:90%;justify-content:center;position:absolute;top:10%;width:60%;");
export var PreviewCurrentSlide =
/*#__PURE__*/
styled("div", {
  target: "e1w6ljo74"
})("border:2px #fff solid;display:flex;flex:0 0 100%;height:55%;width:55%;padding:20px;");
export var PreviewNextSlide =
/*#__PURE__*/
styled("div", {
  target: "e1w6ljo75"
})("align-items:center;display:flex;flex:0 0 68.75%;height:40%;justify-content:center;opacity:0.4;");
export var HeaderContainer =
/*#__PURE__*/
styled("div", {
  target: "e1w6ljo76"
})("position:absolute;display:block;color:#fff;width:100%;height:10%;text-align:center;padding:10px 50px;");
export var Notes =
/*#__PURE__*/
styled("div", {
  target: "e1w6ljo77"
})("color:#fff;display:block;height:90%;left:calc(60% + 50px);padding:10px 30px;position:absolute;top:10%;width:(40% - 100px);overflow:auto;");
export var SlideInfo =
/*#__PURE__*/
styled("h2", {
  target: "e1w6ljo78"
})("position:relative;top:50%;transform:translateY(-50%);float:left;margin:0;line-height:1;display:inline-block;fontsize:28px;");


//////////////////
// WEBPACK FOOTER
// ./node_modules/spectacle/es/components/presenter-components.js
// module id = 791
// module chunks = 0